/*
 * @forgerock/javascript-sdk
 *
 * constants.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
/**
 * @module
 * @ignore
 * These are private constants
 */
var REQUESTED_WITH = 'forgerock-sdk';
export { REQUESTED_WITH };
//# sourceMappingURL=constants.js.map